"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertEan13 = exports.isValidEan13 = void 0;
const errors_1 = require("@wolf/errors");
/**
 * EAN-13 checksum validation: 13 digits where the 13th is `(10 - (sum mod 10)) mod 10`,
 * with sum = sum of first 12 digits weighted alternately by 1 and 3.
 */
const isValidEan13 = (code) => {
    if (!/^\d{13}$/.test(code))
        return false;
    const digits = code.split('').map(Number);
    const checksum = digits
        .slice(0, 12)
        .reduce((sum, digit, i) => sum + digit * (i % 2 === 0 ? 1 : 3), 0);
    const expected = (10 - (checksum % 10)) % 10;
    return expected === digits[12];
};
exports.isValidEan13 = isValidEan13;
const assertEan13 = (code) => {
    if (!(0, exports.isValidEan13)(code)) {
        throw new errors_1.BadRequestError(errors_1.BAD_REQUEST_ERROR_CODES.BAD_PICKING_INPUT, `Invalid EAN-13 code: ${code}`);
    }
};
exports.assertEan13 = assertEan13;
//# sourceMappingURL=gs1.js.map